var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.653,
    height: 102.679,
    fill: "#104864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -1373.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(118 1373.998)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160 1417.998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.269,116.939h0a7.151,7.151,0,0,1-5.108,2.135h0a7.155,7.155,0,0,1-5.1-2.129,7.311,7.311,0,0,1,5.1-12.466h0a7.311,7.311,0,0,1,5.112,12.46M150.923,105a9.634,9.634,0,0,0-6.767-2.843h0a9.632,9.632,0,0,0-6.759,16.422,9.475,9.475,0,0,0,6.763,2.818h.006a9.475,9.475,0,0,0,6.766-2.825A9.632,9.632,0,0,0,150.923,105",
    transform: "translate(-42.07 -31.931)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.677,116.936h0a7.151,7.151,0,0,1-5.108,2.135h0a7.155,7.155,0,0,1-5.1-2.129,7.311,7.311,0,0,1,5.1-12.466h0a7.311,7.311,0,0,1,5.112,12.46M16.331,105a9.634,9.634,0,0,0-6.767-2.843h0A9.632,9.632,0,0,0,2.8,118.576a9.475,9.475,0,0,0,6.763,2.818H9.57a9.475,9.475,0,0,0,6.766-2.825A9.632,9.632,0,0,0,16.331,105",
    transform: "translate(0 -31.931)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,44.238a2.6,2.6,0,0,0,4.006-1c.018-.042.033-.084.047-.126l.991-3.132a2.67,2.67,0,0,0-.72-3.024A48.929,48.929,0,0,0,95.591,26.446a12.928,12.928,0,0,1-2.148,2.143c.525.065.889.113,1.021.131a46.511,46.511,0,0,1,20.577,9.948l.263.222-1.118,3.531-.585-.457a47.7,47.7,0,0,0-18.409-8.87,1.237,1.237,0,0,0-1.483.918,1.213,1.213,0,0,0,.021.615l.029.094-.009.1,0,8.264a17.376,17.376,0,0,1,2.467-.319l0-6.866.662.2A45.728,45.728,0,0,1,112.5,44.238",
    transform: "translate(-29.208 -8.266)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.685,33.236a1.216,1.216,0,0,0-1.132-.322,43.6,43.6,0,0,0-18.9,9.541l-.608.527L36.063,39.6l.229-.217A42.326,42.326,0,0,1,56.865,28.729c.153-.021.526-.072,1.057-.138a12.961,12.961,0,0,1-2.15-2.147A44.754,44.754,0,0,0,34.417,37.761a2.676,2.676,0,0,0-.637,2.823l.877,3.017a1.051,1.051,0,0,0,.042.121,2.6,2.6,0,0,0,4.14.973,41.329,41.329,0,0,1,16.084-8.816l.657-.186,0,7.1a17.619,17.619,0,0,1,2.468.385l0-8.38a1.251,1.251,0,0,0-.023-.23l-.019-.1.021-.1a1.226,1.226,0,0,0-.339-1.129",
    transform: "translate(-10.508 -8.266)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.969,14.782h0a7.151,7.151,0,0,1-5.108,2.135h0a7.155,7.155,0,0,1-5.1-2.129,7.311,7.311,0,0,1,5.1-12.466h0a7.311,7.311,0,0,1,5.112,12.46m1.655-11.94A9.637,9.637,0,0,0,76.855,0h0a9.631,9.631,0,0,0-6.758,16.422,9.473,9.473,0,0,0,6.762,2.818h.007a9.474,9.474,0,0,0,6.766-2.825,9.633,9.633,0,0,0-.006-13.573",
    transform: "translate(-21.034)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.359,81.871c-.031-.047-.06-.1-.09-.145l-.345-.573c-.075-.124-.147-.254-.212-.385-.172-.343-.336-.7-.5-1.087l-3.113,1.4-.069-.717a46.318,46.318,0,0,1,1.744-17.719,2.627,2.627,0,0,0-2.442-3.369c-.047,0-.09,0-.133,0l-3.313.238a2.68,2.68,0,0,0-2.559,1.8,49.559,49.559,0,0,0-1.826,24,13.816,13.816,0,0,1,2.814,1.232c-.153-.574-.255-.975-.29-1.114A47.137,47.137,0,0,1,23.59,62.33L23.7,62l3.773-.27-.206.71a48.3,48.3,0,0,0-1.381,20.679,1.225,1.225,0,0,0,1.182,1.051,1.154,1.154,0,0,0,.8-.271l.188-.1Z",
    transform: "translate(-5.874 -18.528)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,119.685l-.005-.009c-.077-.135-.283-.5-.569-1.016a12.942,12.942,0,0,1-1.191,2.816,45.6,45.6,0,0,0,18.738,15.948,2.627,2.627,0,0,0,1.07.231,2.71,2.71,0,0,0,1.811-.687l2.5-1.952a1.185,1.185,0,0,0,.1-.083,2.621,2.621,0,0,0-.639-4.236l-.027-.014a42.12,42.12,0,0,1-14.425-11.961l-.382-.5,8.9-4.378L47.341,111.9l-9.055,4.452c-.018.011-.055.034-.09.059l-.177.076a1.246,1.246,0,0,0-.97.739,1.218,1.218,0,0,0,.12,1.176A44.437,44.437,0,0,0,53.3,132.645l.714.371-2.828,2.206-.287-.134a43.159,43.159,0,0,1-17.794-15.4",
    transform: "translate(-9.795 -34.977)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,112.629Z",
    transform: "translate(-1.75 -35.205)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,112.629Z",
    transform: "translate(-1.75 -35.205)",
    fill: "#104864",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.264,100.646h0Z",
    transform: "translate(-42.905 -31.459)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.264,100.646h0Z",
    transform: "translate(-42.905 -31.459)",
    fill: "#104864",
    stroke: "#606060",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.921,61.315a2.677,2.677,0,0,0-2.522-1.8l-3.355-.239a1.138,1.138,0,0,0-.12,0,2.626,2.626,0,0,0-2.449,3.37,46.3,46.3,0,0,1,1.744,17.717l-.069.717-3.115-1.4c-.165.394-.329.751-.5,1.088-.066.131-.138.262-.214.388l-.344.571c-.029.049-.058.1-.089.144l4.3,1.93a.593.593,0,0,1,.072.024l.107.061a1.249,1.249,0,0,0,.817.285,1.222,1.222,0,0,0,1.182-1.047,48.29,48.29,0,0,0-1.38-20.682l-.206-.711,3.773.27.107.329a47.086,47.086,0,0,1,1.573,23.074c-.04.161-.144.569-.3,1.145a13.826,13.826,0,0,1,2.814-1.231,49.572,49.572,0,0,0-1.827-24",
    transform: "translate(-38.725 -18.528)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7,121.476a12.631,12.631,0,0,1-1.189-2.823c-.286.52-.489.879-.56,1a43.2,43.2,0,0,1-17.811,15.431l-.286.133-2.828-2.208.714-.369a44.409,44.409,0,0,0,16.126-14.238,1.223,1.223,0,0,0-.812-1.907l-.179-.069c-.069-.043-.108-.067-.147-.088L103.7,111.9l-1.637,1.944,8.9,4.379-.382.5A42.109,42.109,0,0,1,96.126,130.7a2.621,2.621,0,0,0-.642,4.235c.032.03.066.059.1.087l2.47,1.928a2.686,2.686,0,0,0,2.909.477A45.588,45.588,0,0,0,119.7,121.476",
    transform: "translate(-29.594 -34.977)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,71.054a14.371,14.371,0,0,0,1.543,6.88.961.961,0,0,0,.052.094l.4.654,1.473,2.123c.027.041.1.125.129.162l22.376,26.566a2.262,2.262,0,0,0,1.664.729h0a2.3,2.3,0,0,0,1.715-.784L92.729,80.911c.03-.035.057-.069.082-.1l1.521-2.2.346-.577a1,1,0,0,0,.053-.093,14.371,14.371,0,0,0,1.544-6.883c-.2-7.771-6.739-14.168-14.886-14.564-6.232-.309-10.81,4.079-12.492,5.985l-.258.292-.258-.292c-1.622-1.84-5.946-6-11.853-6-.211,0-.423,0-.639.016C47.742,56.887,41.2,63.284,41,71.054M56.023,59.3c4.9-.23,9.137,3.244,11.462,6.577a1.405,1.405,0,0,0,2.3,0c2.329-3.339,6.579-6.817,11.462-6.577,6.575.319,12.053,5.625,12.213,11.827a11.6,11.6,0,0,1-1.217,5.488l-1.721,2.548L68.638,105.152,46.749,79.164l-1.417-2.04-.293-.485a11.61,11.61,0,0,1-1.229-5.512c.162-6.2,5.639-11.507,12.212-11.826",
    transform: "translate(-12.815 -17.653)",
    fill: "#104864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/SizeIcon.8336724c959633b265ed51e7d3e30dde.svg";
export { ForwardRef as ReactComponent };